import type { DeviceChangeEvent } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  ActivityType,
  CGMType,
  DataSource,
  DeviceType,
} from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Label,
  ModalBody,
} from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"


import { EventModalHeader } from "../EventModalHeader"
import { usePolyglot } from "src/contexts"
import styles from "src/styles/entryModal.module.scss"

interface Props {
  userEvent: DeviceChangeEvent;
}

const polyglotPrefix = "components.entry_modal.device_change."

export function DeviceChangeEventModal(props: Props) {
  const {
    userEvent,
  } = props

  const polyglot = usePolyglot()

  const deviceType = userEvent.device_change?.device_type ?? DeviceType.NotProvided
  const device = userEvent.device_change?.device ?? CGMType.Undefined

  const deviceTypeString: string | null = useMemo(
    () => {
      if (deviceType === DeviceType.NotProvided) {
        return null
      }

      if (
        userEvent.source === DataSource.Tandem &&
        deviceType === DeviceType.PumpCartridge
      ) {
        return polyglot.t("device_type.pump_cartridge_tandem")
      }

      return polyglot.t(`device_type.${deviceType}`)
    },
    [
      deviceType,
      polyglot,
      userEvent.source,
    ],
  )

  return (
    <>
      <EventModalHeader
        activityType={ActivityType.DeviceChange}
        userEvent={userEvent}
        closeBtnId="device_change-event-close-btn"
      />
      <ModalBody className={styles.modalBody}>
        {deviceTypeString && (
          <Label sizePreset="small">
            {polyglot.t(
              `${polyglotPrefix}legend_with_device_changed`,
              { device: deviceTypeString },
            )}
          </Label>
        )}
        {device !== CGMType.Undefined && (
          <Label sizePreset="small">
            {polyglot.t(
              `${polyglotPrefix}legend_with_device`,
              {
                device: polyglot.t(`device.${device}`),
              },
            )}
          </Label>
        )}
      </ModalBody>
    </>
  )
}
